import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/cn';

const iconBtnVariants = cva(
  'relative inline-flex items-center justify-center border rounded-[9px] cursor-pointer transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-ring',
  {
    variants: {
      tone: {
        light: 'bg-surface text-ink border-line hover:bg-bg',
        dark: 'bg-[#1c2940] text-[#e8ecf3] border-[#2a3a55] hover:bg-[#233356]',
        ghost: 'bg-transparent text-ink-2 border-transparent hover:bg-[#f0f2f5]',
      },
      size: {
        sm: 'w-7 h-7',
        md: 'w-[34px] h-[34px]',
        lg: 'w-10 h-10',
      },
    },
    defaultVariants: { tone: 'light', size: 'md' },
  }
);

export function IconButton({ icon: Icon, tone, size = 'md', badge, className, label, iconSize, ...props }) {
  const resolvedIcon = iconSize || (size === 'sm' ? 14 : size === 'lg' ? 18 : 16);
  return (
    <button
      aria-label={label}
      className={cn(iconBtnVariants({ tone, size }), className)}
      {...props}
    >
      {Icon && <Icon size={resolvedIcon} strokeWidth={1.7} />}
      {badge && (
        <span
          className="absolute top-1.5 right-1.5 w-[7px] h-[7px] rounded-full bg-bad"
          style={{ border: `1.5px solid ${tone === 'dark' ? '#1c2940' : '#ffffff'}` }}
        />
      )}
    </button>
  );
}

export default IconButton;
